export function getfbpc(){
    let fbp = document.cookie.split(';').filter(c => c.includes('_fbp=')).map(c => c.split('_fbp=')[1]);
    let fbc = document.cookie.split(';').filter(c => c.includes('_fbc=')).map(c => c.split('_fbc=')[1]);
    fbp = (fbp.length && fbp[0]) || null;
    fbc = (fbc.length && fbc[0]) || null;

    // Meta requires the fbclid value unmodified: read just that parameter, not the rest of the query
    const fbclid = !fbc && new URLSearchParams(window.location.search).get('fbclid');
    if (fbclid) {
        fbc = 'fb.1.'+ (+new Date()) +'.'+ fbclid;
    }

    return {fbp, fbc};
}